import styled from 'styled-components';
import { mediaQueryDesktopMin } from 'styleUtils';
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-198b8fb-0"
})(["display:flex;flex-flow:row wrap;margin:0 auto;padding:0 16px;width:100%;@media ", "{max-width:1292px;justify-content:center;}"], mediaQueryDesktopMin);
export default Wrapper;